import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_candles_holders: FaireCategoryEntity = {
  token: "catalog_cat_candles-holders",
  type: "category",
  name: "Candles & holders",
  count: 169,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
